module.exports = __webpack_public_path__ + "img/d20.0df7ec4d.svg";